// extracted by mini-css-extract-plugin
export default {"wrapper":"kACnnU","closeIcon":"qp5Yjy","header":"xb_5j_","content":"vZl_jJ"};